<template>
    <rkm-area
        background-color="danger"
        closed
        header-prefix-text="S"
        title="Subjetivo"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.subjetivo.descricao"
                    label="Impressões subjetivas do profissional e as expressadas pelo paciente"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxMotivoAtendimento
                    v-if="!item.isAtendimentoSaudeBucal"
                    :item="item"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import BoxMotivoAtendimento from './components/motivo-atendimento/Index'
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {BoxMotivoAtendimento, Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>